import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

import { IonButton, IonButtons, IonCard, IonHeader, IonItem, IonList, IonPage, IonPopover, IonToolbar, IonTitle, IonContent } from '@ionic/vue'

import type { EventType } from '@/store/event'
import { eventId } from '@/store/event'
import { collection } from 'firebase/firestore'
import { useFirestore, useCollection } from 'vuefire'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/store/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'ListEvents',
  setup(__props) {

const $auth = useAuthStore()
const $router = useRouter()

const events = useCollection<EventType>(collection(useFirestore(), 'events'))


function openEvent(id: string) {
  eventId.value = id
  $router.push('/event')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), {
        collapse: "fade",
        translucent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), { id: "trigger-user-menu" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Vyber akci")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonPopover), {
        trigger: "trigger-user-menu",
        "trigger-action": "click",
        "dismiss-on-select": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonList), {
            lines: "full",
            class: "ion-no-padding"
          }, {
            default: _withCtx(() => [
              (_unref($auth).currentUser)
                ? (_openBlock(), _createBlock(_unref(IonItem), {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref($auth).logout())),
                    detail: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Odhlásit se ")
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_unref(IonItem), {
                    key: 1,
                    "router-link": "/auth",
                    detail: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Přihlásit se ")
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { fullscreen: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonHeader), { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonTitle), { size: "large" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Vyber akci")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(events), (event) => {
            return (_openBlock(), _createBlock(_unref(IonCard), {
              key: event.id,
              class: "event-banner",
              style: _normalizeStyle({ backgroundImage: `url(${event.bannerUrl})` }),
              button: "",
              onClick: ($event: any) => (openEvent(event.id))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(event.displayName), 1)
              ]),
              _: 2
            }, 1032, ["style", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})